"use client";

import React from "react";
import { ArrowRight, PhoneCall, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForAFreshStart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222837" id="request-your-estimate" className="bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.03]">
        <Sparkles className="size-[40rem] text-primary" strokeWidth={0.5} />
      </div>

      <div className="container mx-auto px-4 relative z-10 sm:px-6 lg:px-8">
        <div ref={ref} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center rounded-sm border border-border bg-muted/50 px-4 py-1.5 text-sm font-medium text-secondary mb-8 backdrop-blur-md">
            <Sparkles className="mr-2 size-4 text-primary" />
            Architectural Guardianship
          </div>

          <h2 className="font-default text-5xl font-bold tracking-tighter sm:text-7xl mb-6 text-foreground">
            Ready to Build Excellence?
          </h2>
          
          <p className="font-default text-lg leading-relaxed text-muted-foreground mb-10 max-w-2xl mx-auto">
            Protech Restoration LLC combines industrial precision with high-end materials to protect your most valuable asset. Schedule your professional assessment for siding, roofing, or custom decking today.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm" asChild>
              <Link to="#">
                Request Your Estimate
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" className="w-full sm:w-auto h-14 px-8 text-base border-border text-foreground hover:bg-accent/50 rounded-sm" asChild>
              <Link to="tel:(555) 248-1234"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone-call mr-2 size-5 text-primary" aria-hidden="true" data-ast-id="f:/src/pages/Gallery/sections/ReadyForAFreshStart.tsx|sig:cxy002" data-ast-start="2520" data-ast-end="2570"><path d="M13 2a9 9 0 0 1 9 9"></path><path d="M13 6a5 5 0 0 1 5 5"></path><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>(475) 330-8380</Link>
            </Button>
          </div>
          
          <p className="mt-8 text-xs uppercase tracking-widest text-muted-foreground font-mono">
            Transparent estimates • Professional scheduling • Guaranteed craftsmanship
          </p>
        </div>
      </div>
    </section>;
}